import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';

export default function Locationmodal({ visible, onHide, companyData, onSave, clients, allBranchs }) {
    const [company, setCompany] = useState(companyData);
    const [submitted, setSubmitted] = useState(false);
    const [filteredBranchs, setFilteredBranchs] = useState([]);

    useEffect(() => {
        if (companyData) {
            setCompany({ ...companyData });
        }
    }, [companyData]);

    // Chained Dropdown: Filter Branches based on selected Client
    useEffect(() => {
        if (company?.client_id) {
            const matches = (allBranchs || []).filter((b) => String(b.client_id) === String(company.client_id));
            setFilteredBranchs(matches);
        } else {
            setFilteredBranchs([]);
        }
    }, [company?.client_id, allBranchs]);

    const onInputChange = (val, name) => {
        let _company = { ...company };
        _company[name] = val;

        // Reset Branch if Client changes
        if (name === 'client_id') {
            _company['branch_id'] = null;
        }

        setCompany(_company);
    };

    const isFormControlInvalid = (name) => {
        const val = company[name];
        if (!submitted) return false;

        if (name === 'location_name') return !val || !val.trim();
        if (['client_id', 'branch_id'].includes(name)) return !val;

        return false;
    };

    const saveLocation = () => {
        setSubmitted(true);
        const isMandatoryFilled = company.location_name?.trim() && company.client_id && company.branch_id;

        if (isMandatoryFilled) {
            onSave(company);
            setSubmitted(false);
        }
    };

    const footer = (
        <div>
            <Button label="Cancel" icon="pi pi-times" outlined onClick={onHide} />
            <Button label="Save" icon="pi pi-check" onClick={saveLocation} />
        </div>
    );

    return (
        <Dialog visible={visible} style={{ width: '450px' }} header="Location Details" modal className="p-fluid" footer={footer} onHide={onHide}>
            <div className="grid mt-2">
                {/* Client Dropdown */}
                <div className="field col-12">
                    <label className="font-bold">Client *</label>
                    <Dropdown
                        value={company.client_id}
                        options={clients}
                        onChange={(e) => onInputChange(e.value, 'client_id')}
                        optionLabel="client_name"
                        optionValue="client_id"
                        placeholder="Select Client"
                        className={classNames({ 'p-invalid': isFormControlInvalid('client_id') })}
                        filter
                    />
                    {isFormControlInvalid('client_id') && <small className="p-error">Client is required.</small>}
                </div>

                {/* Branch Dropdown */}
                <div className="field col-12">
                    <label className="font-bold">Branch *</label>
                    <Dropdown
                        value={company.branch_id}
                        options={filteredBranchs}
                        onChange={(e) => onInputChange(e.value, 'branch_id')}
                        optionLabel="branch_name"
                        optionValue="branch_id"
                        placeholder="Select Branch"
                        disabled={!company.client_id}
                        className={classNames({ 'p-invalid': isFormControlInvalid('branch_id') })}
                        filter
                    />
                    {isFormControlInvalid('branch_id') && <small className="p-error">Branch is required.</small>}
                </div>

                {/* Location Name Input */}
                <div className="field col-12">
                    <label className="font-bold">Location Name *</label>
                    <InputText value={company.location_name || ''} onChange={(e) => onInputChange(e.target.value, 'location_name')} className={classNames({ 'p-invalid': isFormControlInvalid('location_name') })} />
                    {isFormControlInvalid('location_name') && <small className="p-error">Location Name is required.</small>}
                </div>
            </div>
        </Dialog>
    );
}
